import React from 'react';
import PropTypes from 'prop-types';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import { Field, reduxForm } from 'redux-form';
import { Grid, Card, CardContent, Icon, Fab } from '@material-ui/core';
import StandardDialog from './StandardDialog';
import RenderSelectFieldRedux from './RenderSelectFieldRedux';
import RenderRadioGroup from './RenderRadioGroup';
//import renderSelectField from './renderSelectField';


const validate = values => {
    const error  = {}
    if (!values.name) {
        error.name = "El nombre es un campo obligatorio"
    }
    if (!values.email) {
        error.email = "El email es un campo obligatorio"
    }
    if (!values.number) {
        error.number = "La número de cuenta es un campo obligatorio"
    }
    if (!values.document) {
        error.document = "El tipo de documento es obligatorio"
    }
    if (!values.cedule) {
        error.cedule = "El campo número de documento es obligatorio"
    }
    return error
}

const ExternalForm = props => {
    const { handleSubmit, onCancelAction, entities, institutions, changeEntity, submitting, pristine, setDocument, document } = props
    //const [ document, setDocument] = useState('Cédula')
    
    return  <Card  variant="outlined"> 
                <CardContent>
                    <form onSubmit = {handleSubmit}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <Field
                                    data = {entities.TiposInstitucion}
                                    labelId="demo-simple-select-filled-label"
                                    id="entity"
                                    name="entity"
                                    label= { "Entidad" }
                                    onChange ={ e => { changeEntity(e.target.value) } }
                                    component={ RenderSelectFieldRedux } />
                                {/* <Field
                                    name="entity"
                                    id= "entity"
                                    component = { renderSelectField }
                                    onChange ={ e => { changeEntity(e.target.value) } }
                                    // value={dateValue}
                                    label="Entidad">
                                        {
                                        entities.TiposInstitucion.map((v, k) => {
                                                return <option key = {v.Codigo} value={v.Codigo}>{v.Nombre}</option>
                                            } )
                                        }
                                </Field> */}
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <Field
                                    data = {institutions}
                                    labelId="demo-simple-select-filled-label"
                                    id="institution"
                                    name="institution"
                                    label= { "Seleccione la institución" }
                                    component={ RenderSelectFieldRedux } />
                                {/* <Field
                                    name="institution"
                                    id= "institution"
                                    component = { renderSelectField }
                                    // onChange ={ e => { changeEntity(e.target.value) } }
                                    value={initialValues.institution}
                                    label="Seleccione la institucion">
                                        {
                                            institutions.map((v, k) => {
                                                return <option key = {v.Secuencial} value={v.Secuencial}>{v.Nombre}</option>
                                            } )
                                        }
                                </Field> */}
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <Field
                                    data = {
                                        entities.TiposCuenta.filter( external => {
                                            if (external.EsInterna) return false 
                                            else return true
                                        })
                                    }
                                    labelId="demo-simple-select-filled-label"
                                    id="type"
                                    name="type"
                                    label= { "Tipo de cuenta" }
                                    component={ RenderSelectFieldRedux } />
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <Field
                                    name="document"
                                    id="document"
                                    required
                                    row
                                    data = {
                                        [
                                            {label: 'Cédula', value:'1' },
                                            {label: 'RUC', value:'2' },
                                            {label: 'PASAPORTE', value:'6' },
                                        ]
                                    }
                                    document = {document}
                                    component={ RenderRadioGroup }
                                    label="Tipo de documento"
                                    setVal = { setDocument }
                                    valor={document}
                                    //values={document}
                                >
                                </Field>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Field
                                    withFocus
                                    name="cedule"
                                    id="cedule"
                                    required
                                    // valueData = { cedule }
                                    component={ RenderTextFieldRedux }
                                    label={ 'Número de identificación' }
                                    type={ (document === '6') ? "text" : "number"}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Field
                                    withFocus
                                    name="number"
                                    id="number"
                                    required
                                    component={ RenderTextFieldRedux }
                                    label="Número de cuenta"
                                    type="number"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Field
                                    name="name"
                                    id="name"
                                    required
                                    component={ RenderTextFieldRedux }
                                    label="Nombre"
                                    type="text"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Field
                                    withFocus
                                    name="email"
                                    id="email"
                                    required
                                    textTransform = "lowercase"
                                    component={ RenderTextFieldRedux }
                                    label="Correo Electrónico"
                                    fullWidth
                                />
                            </Grid>
                            <br></br>
                            <Grid item xs={4} md={4}>
                            <Fab color="primary" aria-label="add" type="submit" disabled={pristine || submitting}  >
                                <Icon>done</Icon>
                            </Fab>
                            </Grid>
                            <Grid item xs={4} md={4}>
                                <Fab style={{backgroundColor: '#E35959'}} aria-label="add" onClick = {  () => onCancelAction() }>
                                    <Icon>clear</Icon>
                                </Fab>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
}

const ExternalReduxForm = reduxForm(
    {
      form: 'ExternalForm',
      validate,
    }
)(ExternalForm)


const BeneficiaryExternalForm = props => {
    const {  onCloseBeneficiaryForm, externalBeneficiary , entities, institutions, changeEntity, onAcceptClick, onDeleteClick, setDocument, document, beneficiaries, handleOpenSnack} = props
    const {open, data } = externalBeneficiary
    //console.log(externalBeneficiary)

    const handleSubmit = (values) => {
        values.document = document;
        //console.log("Data entrada: ", data)
        //console.log("Data saliente: ", values)

        if(data.number !== values.number){

            const dataResult = beneficiaries.filter((beneficiary) => {
                    
                if ((beneficiary.number === values.number) && (beneficiary.beneficiary === "EXTERNO")) {
                    return true
                } else {
                    return false
                }
            })
            
            if(dataResult.length === 0){
                onAcceptClick(values)
            }else{
                handleOpenSnack('El beneficiario ya existe. Por favor verifique los datos.', 'info');
            }
        }else{
            onAcceptClick(values)
        }
    }

    const onDelete = (values) => {
        onDeleteClick(values)
    }

   
    
    return (
            <StandardDialog
                title = { 'Editar beneficiario'}
                open = {open}
                handleClose = {onCloseBeneficiaryForm}
            >
                <ExternalReduxForm
                    onSubmit = { handleSubmit }
                    onCancelAction = {onCloseBeneficiaryForm}
                    onDeleteAction = { onDelete }
                    entities = {entities}
                    institutions = {institutions}
                    changeEntity = {changeEntity}
                    initialValues = {data} 
                    setDocument = {setDocument}
                    document = {data.document}
                />
            </StandardDialog>
    );
};

BeneficiaryExternalForm.propTypes = {
    onCloseBeneficiaryForm: PropTypes.func.isRequired,
    onAcceptClick: PropTypes.func.isRequired,
}

export default BeneficiaryExternalForm;